<template>
<el-dialog :title="!dataForm.id ? '新增' : '修改'" width="60%" :append-to-body="true" :close-on-click-modal="false" :visible.sync="view.visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="code-type-dialog-form">
        <div class="des_box">
            <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px">
                <el-descriptions-item label="订单编码" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="orderCode" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.orderCode" size="small" placeholder="订单编码"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="物料编码" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="partCode" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.partCode" size="small" placeholder="物料编码"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="零件名称" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="partName" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.partName" size="small" placeholder="零件名称"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="箱种" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="boxType" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.boxType" size="small" placeholder="箱种"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="收容数" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="inCount" style="margin-bottom: 0;">
                        <!-- <el-input v-model="dataForm.inCount" size="small" placeholder="收容数"></el-input> -->
                        <ctl-number size="small" v-model="dataForm.inCount" :min="0" :max="999" label="描述文字"></ctl-number>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="送货箱数" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="deliveredBoxCount" style="margin-bottom: 0;">
                        <!-- <el-input v-model="dataForm.deliveredBoxCount" size="small" placeholder="送货箱数"></el-input> -->
                        <ctl-number size="small" v-model="dataForm.deliveredBoxCount" :min="0" :max="999" label="描述文字"></ctl-number>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="送货数量" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="deliveredCount" style="margin-bottom: 0;">
                        <!-- <el-input v-model="dataForm.deliveredCount" size="small" placeholder="送货数量"></el-input> -->
                        <ctl-number size="small" v-model="dataForm.deliveredCount" :min="0" :max="999" label="描述文字"></ctl-number>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="实收数量" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="recieveCount" style="margin-bottom: 0;">
                        <!-- <el-input v-model="dataForm.recieveCount" size="small" placeholder="实收数量"></el-input> -->
                        <ctl-number size="small" v-model="dataForm.recieveCount" :min="0" :max="999" label="描述文字"></ctl-number>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="批号" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="batchNumber" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.batchNumber" size="small" placeholder="批号"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="单位" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="unit" style="margin-bottom: 0;">
                        <!-- <el-input v-model="dataForm.unit" size="small" placeholder="单位"></el-input> -->
                        <el-select v-model="dataForm.unit"  filterable  placeholder="请选择">
                            <el-option v-for="item in unitList" :key="item.code" :label="item.name" :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="备注" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="remark" style="margin-bottom: 0;">
                        <el-input type="textarea" :rows="3" v-model="dataForm.remark" size="small" placeholder="备注"></el-input>
                    </el-form-item>
                </el-descriptions-item>
            </el-descriptions>
        </div>
    </el-form>
    <el-row>
        <el-col style="text-align: right">
            <el-button size="small" @click="view.visible = false">
                <span class="font-12 iconfont myicon-quxiao1"></span>&nbsp;
                取消
            </el-button>
            <el-button size="small" type="primary" @click="dataFormSubmit()">
                <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;
                确定
            </el-button>
        </el-col>
    </el-row>
</el-dialog>
</template>

<script>
import {
    getPartById,
    createDeliveryPart,
    editDeliveryPart,
} from "@/controller/delivery";
import {
    getUnitList
} from '@/controller/systemData'
import CtlNumber from '@/views/common/ctl-number'
export default {
    data() {
        return {
            view: {
                visible: false,
                conheight: {
                    height: this.$store.state.common.documentClientDefaultHeight * 0.9 - 410 + "px",
                    "overflow-y": "auto",
                },
            },
            viewData: {},
            unitList : [],
            dataForm: {
                id: 0,
                orderCode: "",
                partCode: "",
                partName: "",
                boxType: "",
                inCount: "",
                deliveredBoxCount: "",
                deliveredCount: "",
                unit: "",
                batchNumber: "",
                recieveCount: "",
                remark: "",
                deliveryId: "",
            },
            // 开始
            dataRule: {
                name: [{
                    required: true,
                    message: "编码名称不能为空",
                    trigger: "blur",
                }, ],
                type: [{
                    required: true,
                    message: "编码类型不能为空",
                    trigger: "blur",
                }, ],
            },
        };
    },
    components: {
        CtlNumber
    },
    methods: {
        // 初始化
        init(id, deliveryId) {
            // debugger;
            console.log(this.dataForm);
            this.dataForm.id = id || 0;
            this.dataForm.deliveryId = deliveryId;
            this.view.visible = true;
            this.$nextTick(() => {
                this.$refs["dataForm"].resetFields();
                console.log(this.dataForm);
                if (this.dataForm.id) {
                    // 根据id查零件
                    getPartById({}, this.dataForm.id).then((data) => {
                        if (data && data.code === "00") {
                            this.dataForm = data.body;
                        }
                    });
                }
                 this.getUnitList()
            });
        },
        getUnitList() {
            getUnitList({
                code: "",
                name: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.unitList = data.body;
                }
            });
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    let deliveryPartParams = {
                        id: this.dataForm.id || undefined,
                        orderCode: this.dataForm.orderCode,
                        partCode: this.dataForm.partCode,
                        partName: this.dataForm.partName,
                        boxType: this.dataForm.boxType,
                        inCount: this.dataForm.inCount,
                        deliveredBoxCount: this.dataForm.deliveredBoxCount,
                        deliveredCount: this.dataForm.deliveredCount,
                        unit: this.dataForm.unit,
                        batchNumber: this.dataForm.batchNumber,
                        recieveCount: this.dataForm.recieveCount,
                        remark: this.dataForm.remark,
                        deliveryId: this.dataForm.deliveryId,
                    };
                    if (this.dataForm.id) {
                        // 更新零件
                        editDeliveryPart(deliveryPartParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.view.visible = false;
                                            this.$emit(
                                                "refreshDeliveryPartDataList"
                                            );
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    } else {
                        // 创建零件
                        createDeliveryPart(deliveryPartParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.view.visible = false;
                                            this.$emit(
                                                "refreshDeliveryPartDataList"
                                            );
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    }
                }
            });
        },
        getStyle() {
            return 'width: 100px; text-align: right'
        },
        getStyle2() {
            return 'width: 455.5px;'
        }
    },
};
</script>

<style lang="scss" scoped>
.el-dialog__body {
    .code-type-dialog-form {
        width: 100%;
    }
}
</style>
